import { render, staticRenderFns } from "./AwardstListGrid.vue?vue&type=template&id=3ee70b2c&"
import script from "./AwardstListGrid.vue?vue&type=script&lang=js&"
export * from "./AwardstListGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports